module.exports = __webpack_public_path__ + "img/Danae.287d9d76.jpg";